module.exports = __webpack_public_path__ + "static/media/vincentvermeulen.e82d7391.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vincentvermeulen.webp
// module id = 522
// module chunks = 0